module.exports = __webpack_public_path__ + "media/images/bg-footer-6d48c4941c83834dca4837dfd46fd006.gif";